define("shared/components/shared/ui/group-item", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <li class="o--dropBody__item">
    <Shared::Ui::Button
      @class={{concat-classes "o--dropBody__link u--ellipsis" (if @isSelected "is--active")}}
      @onClick={{this.transition}}
      @variant="unstyled"
    >
      <Shared::Ui::GroupAvatar @group={{@group}} />
      {{svg-jar "check" class="o--icon o--dropBody__listIcon--right"}}
    </Shared::Ui::Button>
  </li>
  */
  {
    "id": "uBmIeDC5",
    "block": "[[[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@class\",\"@onClick\",\"@variant\"],[[28,[37,1],[\"o--dropBody__link u--ellipsis\",[52,[30,1],\"is--active\"]],null],[30,0,[\"transition\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,3],null,[[\"@group\"],[[30,2]]],null],[1,\"\\n    \"],[1,[28,[35,4],[\"check\"],[[\"class\"],[\"o--icon o--dropBody__listIcon--right\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13]],[\"@isSelected\",\"@group\"],false,[\"shared/ui/button\",\"concat-classes\",\"if\",\"shared/ui/group-avatar\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/group-item.hbs",
    "isStrictMode": false
  });
  let GroupItemComponent = _exports.default = (_class = class GroupItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "router", _descriptor, this);
      _initializerDefineProperty(this, "userAgent", _descriptor2, this);
    }
    get currentRoute() {
      return this.router.currentRoute;
    }
    get transitionRoute() {
      if (this.router.currentRouteName.includes('partnerships')) {
        return 'cluster.partnerships';
      }
      return 'cluster.linkinbio';
    }
    transition() {
      this.args.closeMenu();
      if (this.router.currentRouteName.includes('campaign-application')) {
        this.router.transitionTo(this.currentRoute.name, this.args.group.slug, this.currentRoute.params.campaign_id);
      } else if (this.userAgent.device.isMobile) {
        this.router.transitionTo(this.transitionRoute, this.args.group.slug);
      } else {
        this.router.transitionTo('cluster.schedule', this.args.group.slug);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "transition", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transition"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GroupItemComponent);
});